import type { Permission } from '@aeris/permissions'

/**
 * As colunas que o operador escolhe numa lista — F127.
 *
 * Três perguntas, cada uma com uma resposta só, para Produtos e Clientes:
 *
 * 1. **Quais esta pessoa pode ligar?** As que o papel dela alcança. Custo não
 *    aparece no menu de quem não edita o produto — oferecer e mostrar vazio
 *    diria que o produto não tem custo.
 * 2. **Quais aparecem?** As ligadas, mais as travadas (o nome: uma lista sem
 *    nome é uma tabela de números de ninguém).
 * 3. **Como fica a lista depois de um clique?** Liga ou desliga uma, sem mexer
 *    nas outras — inclusive nas que a pessoa ligou com outro papel e hoje não
 *    alcança, que voltam se o papel voltar.
 */

export type ColumnRule<Id extends string> = {
  readonly id: Id
  readonly label: string
  /** Todas precisam valer. Vazio é "qualquer um que vê a lista". */
  readonly requires: readonly Permission[]
  /** Sempre visível, e o menu mostra marcada e travada. */
  readonly locked?: boolean
}

export const availableColumns = <C extends ColumnRule<string>>(
  columns: readonly C[],
  allows: (permission: Permission) => boolean
): C[] => columns.filter((column) => column.requires.every(allows))

export const shownColumnsOf = <C extends ColumnRule<string>>(
  available: readonly C[],
  visible: readonly string[]
): C[] =>
  available.filter(
    (column) => column.locked === true || visible.includes(column.id)
  )

export const toggledColumns = <Id extends string>(
  visible: readonly Id[],
  id: Id
): Id[] =>
  visible.includes(id)
    ? visible.filter((entry) => entry !== id)
    : [...visible, id]
